import { render, staticRenderFns } from "./product-card-weekly.vue?vue&type=template&id=6248261b&scoped=true&"
import script from "./product-card-weekly.vue?vue&type=script&lang=js&"
export * from "./product-card-weekly.vue?vue&type=script&lang=js&"
import style0 from "./product-card-weekly.vue?vue&type=style&index=0&id=6248261b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248261b",
  null
  
)

export default component.exports